import React from 'react'
import {useProgram} from '../context/ProgramContext';
import {Modal,Button} from 'react-bootstrap'
import Message from './Message'
import ProgramEditor from './ProgramEditor';

export default function ProgramEditorModal() {
const {setEditModalIsVisible,selectedProgram,editModalIsVisible,setMessage,message,selectedProgramId,actionType,updateProgram,saveProgram}=useProgram();
  const hideMessageAndContinueEditing=()=>{
    setMessage({target:"programModal",header:"",text:"",variant:"",buttons:[],isVisible:false})
  }
  const hideMessageAndHideModal=()=>{
    setMessage({target:"programModal",header:"",text:"",variant:"",buttons:[],isVisible:false})
    setEditModalIsVisible(false);
    
  }

  const handleSaveProgram=()=>{
    console.log(selectedProgramId)

    if (actionType==="edit"){
      // let toEditProgramIndex=userPrograms.findIndex(program=>program._id===selectedProgramId)
      // if (toEditProgramIndex>-1) {
      //   let updatedUserPrograms= userPrograms;
      //   updatedUserPrograms[toEditProgramIndex]=selectedProgram;
      //   setUserPrograms(updatedUserPrograms);
      // }
      updateProgram(selectedProgram._id)
    }
    if (actionType==="add"){
      saveProgram(selectedProgramId)
    }
    
    setEditModalIsVisible(false);
    
  }
  
  const handleClose=()=>{
    setMessage({target:"programModal",header:"Are You Sure",
                text:"You are canceling without saving, note that all unsaved information will be be lost ",
                variant:"warning",
                buttons:[{text:"Yes",action:hideMessageAndHideModal},
                         {text:"No",action:hideMessageAndContinueEditing}],
                isVisible:true})
     
  }



    return (
        <>
        <Modal show={editModalIsVisible} onHide={handleClose} size='lg' centered fullscreen="lg-down">
          <Modal.Header closeButton>
            <Modal.Title>Edit Program</Modal.Title>
          </Modal.Header>
    
          <Modal.Body>
            {message.target==="programModal"?
            <Message
             
              header={message.header}
              text={message.text}
              buttons={message.buttons}
              show={message.isVisible}
              variant={message.variant}
              position="fixed"
            ></Message>:null}
            <ProgramEditor/>
          </Modal.Body>
    
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>Close</Button>
            <Button variant="primary" onClick={handleSaveProgram}>Save changes</Button>
          </Modal.Footer>
        </Modal>
        </>
      )
}
